<script lang="ts">
import type { HTMLAttributes } from 'vue'
import type { InputGroupProps } from '#ui-kit/ui/input-group'

export interface PasswordInputProps {
  class?: HTMLAttributes['class']
  size?: InputGroupProps['size']
  error?: InputGroupProps['error']
  disabled?: boolean
}
</script>

<script setup lang="ts">
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue'
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from '#ui-kit/ui/input-group'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<PasswordInputProps>(), {
  size: 'md',
})

const modelValue = defineModel<string | number | null>()

const visible = ref(false)
</script>

<template>
  <InputGroup :size="props.size" :error="props.error" :disabled="props.disabled" :class="props.class">
    <InputGroupInput v-bind="$attrs" v-model="modelValue" :type="visible ? 'text' : 'password'" />
    <InputGroupAddon>
      <InputGroupButton aria-label="Show password" :aria-pressed="visible" @click="visible = !visible">
        <EyeIcon v-if="visible" />
        <EyeSlashIcon v-else />
      </InputGroupButton>
    </InputGroupAddon>
  </InputGroup>
</template>
